<template>
  <b-row class="mr-0">
    <b-modal id="modal-punish" size="lg" centered :title="$store.state.modal.kirimWarning" v-model="localVisible" @hidden="$emit('close')">
      <b-form>
        <!-- 1. Title -->
        <!-- <b-form-group :label="$store.state.form.judul" label-cols-md="3">
          <b-form-input type="text" :state="checkIfValid('judul')" v-model="$v.data.judul.$model" autofocus></b-form-input>
        </b-form-group> -->

        <!-- 2. Target -->
        <!-- <b-form-group :label="$store.state.form.target" label-cols-md="3">
          <b-form-select :options="targetOptions" v-model="$v.data.target.$model" :state="checkIfValid('target')"></b-form-select>
        </b-form-group> -->

        <!-- Divisi (only if target = 'division') -->
        <b-form-group v-if="data.target === 'division'" label="Divisi" label-cols-md="3">
          <div class="w-100">
            <Multiselect
              id="Divisi"
              v-model="$v.data.masterDivisiId.$model"
              :options="divisiOptions"
              :multiple="true"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="-- Pilih Divisi --"
              label="namaDivisi"
              track-by="masterDivisiId"
              class="multiselect-bootstrap"
            />
          </div>
        </b-form-group>

        <!-- Posisi (only if target = 'position') -->
        <b-form-group v-if="data.target === 'position'" label="Posisi" label-cols-md="3">
          <div class="w-100">
            <Multiselect
              id="Posisi"
              v-model="$v.data.masterPosisiId.$model"
              :options="posisiOptions"
              :multiple="true"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="-- Pilih Posisi --"
              label="namaPosisi"
              track-by="masterPosisiId"
              class="multiselect-bootstrap"
            />
          </div>
        </b-form-group>

        <!-- User (only if target = 'user') -->
        <!-- <b-form-group v-if="data.target === 'user'" label="User" label-cols-md="3">
          <div class="w-100">
            <Multiselect
              id="User"
              v-model="$v.data.masterUserId.$model"
              :options="userOptions"
              :multiple="true"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="-- Pilih User --"
              label="namaKaryawan"
              track-by="masterUserId"
              class="multiselect-bootstrap"
            />
          </div>
        </b-form-group> -->

        <!-- 4. File Upload -->
        <b-form-group :label="$store.state.form.file" label-cols-md="3">
          <b-form-file v-model="data.file" :state="checkIfValid('file')" browse-text="Pilih File" placeholder="Pilih atau seret file ke sini..."></b-form-file>
        </b-form-group>

        <!-- 5. Broadcast Date -->
        <!-- <b-form-group :label="$store.state.form.broadcastDate" label-cols-md="3">
          <b-form-datepicker v-model="$v.data.broadcastDate.$model" :state="checkIfValid('broadcastDate')" reset-button locale="id"></b-form-datepicker>
        </b-form-group> -->
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" class="text-dark mr-2" @click="closeModal">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="success" class="text-white" @click="send"> {{ $store.state.form.kirim }} </b-button>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  name: "ModalPunish",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dataPunish: {
      type: Object,
    },
  },
  data() {
    return {
      data: {
        judul: "",
        target: "user",
        masterUserId: [],
        masterDivisiId: [],
        masterPosisiId: [],
        file: null,
        broadcastDate: null,
        tipe: "warning",
        isi: null,
        all: false,
      },
      busy: false,
      button: "Simpan",
      targetOptions: [
        { value: "all", text: "All" },
        { value: "user", text: "User" },
        { value: "division", text: "Division" },
        { value: "position", text: "Position" },
      ],
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    isValid() {
      return !this.$v.data.$invalid;
    },
    localVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  mixins: [validationMixin],
  validations() {
    return {
      data: {
        file: { required },
        // broadcastDate: { required },
      },
    };
  },
  methods: {
    closeModal() {
      this.localVisible = false;
      this.$emit("close");
    },
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) return null;
      return !field.$invalid;
    },
    send() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$bvToast.toast("Silakan lengkapi data terlebih dahulu", {
          title: "Validasi",
          variant: "danger",
          solid: true,
        });
        return;
      }
      this.busy = true;
      this.button = this.$store.state.form.tunggu;
      const formData = new FormData();
      formData.append("masterUserId", [this.dataPunish.id]);
      formData.append("all", this.data.all);
      formData.append("file1", this.data.file);
      formData.append("tipe", this.data.tipe);
      formData.append("judul", "Warning Letter");
      // formData.append("broadcastDate", this.data.broadcastDate);
      this.$axios
        .post("announcement/register", formData)
        .then((res) => {
          this.$emit("alertFromChild", {
            variant: res.data.message === "sukses" ? "success" : "danger",
            msg: res.data.message === "sukses" ? "BERHASIL MENDAFTARKAN ANNNOUNCEMENT" : res.data.message.toUpperCase(),
            showing: true,
          });
          this.resetForm();
          this.closeModal();
        })
        .catch((err) => {
          this.$emit("alertFromChild", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        })
        .finally(() => {
          this.busy = false;
          this.button = this.$store.state.form.simpan;
        });
    },
    resetForm() {
      this.data = {
        judul: "",
        target: "",
        user: "",
        file: null,
        broadcastDate: null,
        tipe: "announcement",
        all: false,
      };
      this.$v.$reset();
    },
  },
  watch: {
    lang() {
      this.button = this.$store.state.form.simpan;
    },
  },
};
</script>

<style scoped>
.text-white-hover:hover {
  color: white !important;
}
</style>
